var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "print-engine-preview",
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('header', {
    staticClass: "preview-heading"
  }, [_vm._m(0), _c('div', {
    staticClass: "preview-actions"
  }, [_c('div', {
    staticClass: "quantity-control"
  }, [_vm._m(1), _c('div', {
    staticClass: "quantity-input"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Diminuir quantidade",
      "disabled": _vm.loading || _vm.quantity <= 1
    },
    on: {
      "click": function click($event) {
        return _vm.changeQuantity(_vm.quantity - 1);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus"
  })]), _c('input', {
    attrs: {
      "id": "etiqueta-preview-quantity",
      "type": "number",
      "min": "1",
      "max": _vm.maxQuantity,
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.quantity
    },
    on: {
      "change": function change($event) {
        return _vm.changeQuantity($event.target.value);
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Aumentar quantidade",
      "disabled": _vm.loading || _vm.quantity >= _vm.maxQuantity
    },
    on: {
      "click": function click($event) {
        return _vm.changeQuantity(_vm.quantity + 1);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])])]), _c('button', {
    staticClass: "generate-preview-button btn btn-primary font-weight-bold",
    class: {
      'spinner spinner-light spinner-right': _vm.loading
    },
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('generate');
      }
    }
  }, [!_vm.loading ? _c('i', {
    staticClass: "fas fa-file-pdf mr-2"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.loading ? "Gerando prévia..." : _vm.generateLabel) + " ")])])]), _c('div', {
    staticClass: "preview-state-bar"
  }, [_vm.loading ? _c('span', {
    staticClass: "preview-status loading"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin"
  }), _vm._v(" Gerando agora ")]) : _vm.error ? _c('span', {
    staticClass: "preview-status error"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle"
  }), _vm._v(" Falha ao atualizar ")]) : _vm.outdated ? _c('span', {
    staticClass: "preview-status outdated"
  }, [_c('i', {
    staticClass: "fas fa-clock"
  }), _vm._v(" Prévia desatualizada ")]) : _vm.pdfUrl ? _c('span', {
    staticClass: "preview-status ready"
  }, [_c('i', {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Prévia atualizada ")]) : _c('span', {
    staticClass: "preview-status idle"
  }, [_c('i', {
    staticClass: "far fa-file-pdf"
  }), _vm._v(" Prévia ainda não gerada ")]), _vm.outdated && !_vm.loading ? _c('small', [_vm._v("Clique em "), _c('strong', [_vm._v("Atualizar prévia")]), _vm._v(" para aplicar as últimas alterações.")]) : !_vm.pdfUrl && !_vm.loading ? _c('small', [_vm._v("A geração é manual para deixar a edição mais rápida.")]) : _vm._e()]), _c('div', {
    staticClass: "preview-stage"
  }, [_vm.pdfUrl ? _c('object', {
    key: _vm.revision,
    staticClass: "preview-frame",
    attrs: {
      "data": _vm.pdfUrl,
      "type": "application/pdf",
      "aria-label": "PDF real da etiqueta gerado pelo motor de impressão"
    }
  }, [_c('div', {
    staticClass: "preview-empty error"
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt"
  }), _c('strong', [_vm._v("Seu navegador não exibiu o PDF neste quadro")]), _c('a', {
    attrs: {
      "href": _vm.pdfUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Abrir a prévia em outra guia")])])]) : _vm.loading ? _c('div', {
    staticClass: "preview-empty"
  }, [_c('span', {
    staticClass: "spinner spinner-primary spinner-lg"
  }), _c('strong', [_vm._v("Preparando a prévia fiel...")]), _c('small', [_vm._v("O canvas continua disponível para edição.")])]) : _vm.error ? _c('div', {
    staticClass: "preview-empty error"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle"
  }), _c('strong', [_vm._v("Não foi possível gerar a prévia")]), _c('small', [_vm._v(_vm._s(_vm.error))]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('generate');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-redo mr-1"
  }), _vm._v("Tentar novamente ")])]) : _c('div', {
    staticClass: "preview-empty"
  }, [_c('i', {
    staticClass: "far fa-file-image"
  }), _c('strong', [_vm._v("A prévia aparecerá aqui")]), _c('small', [_vm._v("Faça uma alteração ou aguarde o carregamento do modelo.")])]), _vm.loading && _vm.pdfUrl ? _c('div', {
    staticClass: "preview-updating"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin"
  }), _vm._v(" Atualizando conforme suas alterações ")]) : _vm._e()]), _vm.error && _vm.pdfUrl ? _c('div', {
    staticClass: "preview-message error"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle"
  }), _c('span', [_vm._v(_vm._s(_vm.error))]), _c('button', {
    staticClass: "btn btn-xs btn-light-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('generate');
      }
    }
  }, [_vm._v(" Tentar novamente ")])]) : _vm._e(), _vm.warnings.length ? _c('div', {
    staticClass: "preview-message warning"
  }, [_c('i', {
    staticClass: "fas fa-ruler-combined"
  }), _c('div', [_c('strong', [_vm._v("Confira as medidas")]), _vm._l(_vm.warnings, function (warning) {
    return _c('span', {
      key: warning
    }, [_vm._v(_vm._s(warning))]);
  })], 2)]) : _vm._e(), _vm._m(2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "preview-title"
  }, [_c('span', {
    staticClass: "preview-icon"
  }, [_c('i', {
    staticClass: "fas fa-print"
  })]), _c('div', [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Conferência fiel")]), _c('h6', [_vm._v("Prévia do motor de impressão")]), _c('p', [_vm._v(" Este quadro usa o mesmo desenho processado pelo servidor que gera o PDF. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    attrs: {
      "for": "etiqueta-preview-quantity"
    }
  }, [_c('strong', [_vm._v("Quantidade")]), _c('small', [_vm._v("Vale também para a impressão teste")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v(" Este é o PDF real do motor. Ele só muda quando você clica em "), _c('strong', [_vm._v("Gerar/Atualizar prévia")]), _vm._v("; ainda assim, use "), _c('strong', [_vm._v("Impressão teste")]), _vm._v(" antes de publicar. ")]);
}];
export { render, staticRenderFns };